import { render, staticRenderFns } from "./data-subject-match-rules-tab.vue?vue&type=template&id=04b5c20b"
import script from "./data-subject-match-rules-tab.vue?vue&type=script&lang=js"
export * from "./data-subject-match-rules-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports